import React from 'react'
import { Form, Input } from 'semantic-ui-react'
import { Field } from 'react-final-form'
import { QUANTITY_UNIT_OPTIONS } from '../../../consts'

export const Dosage = () => {
  return (
    <>
      <Field
        name="amount"
        formatOnBlur={true}
        format={(value: string | undefined) => (value ? value.trim() : '')}
      >
        {({ input, meta }) => (
          <Form.Field error={meta.touched && meta.error}>
            <label>Amount</label>
            <Form.Input
              placeholder="string"
              error={meta.touched && meta.error}
              type="text"
              {...input}
            />
          </Form.Field>
        )}
      </Field>

      <Field
        name="dosage"
        formatOnBlur={true}
        format={(value: string | undefined) => (value ? value.trim() : '')}
      >
        {({ input, meta }) => (
          <Form.Field error={meta.touched && meta.error}>
            <label>Dosage</label>
            <Form.Input
              placeholder="string"
              error={meta.touched && meta.error}
              type="text"
              {...input}
            />
          </Form.Field>
        )}
      </Field>

      <Field name="cbd_dosage_milligrams" type="number">
        {({ input, meta }) => (
          <Form.Field error={meta.touched && meta.error}>
            <label>CBD Dosage</label>
            <Input
              type="number"
              placeholder="number"
              error={meta.touched && meta.error}
              label={{ basic: true, content: 'mg' }}
              labelPosition="right"
              min="0"
              step="0.01"
              {...input}
            />
          </Form.Field>
        )}
      </Field>

      <Field name="thc_dosage_milligrams" type="number">
        {({ input, meta }) => (
          <Form.Field error={meta.touched && meta.error}>
            <label>THC Dosage</label>
            <Input
              type="number"
              placeholder="number"
              error={meta.touched && meta.error}
              label={{ basic: true, content: 'mg' }}
              labelPosition="right"
              min="0"
              step="0.01"
              {...input}
            />
          </Form.Field>
        )}
      </Field>

      <Field name="net_weight_grams" type="number">
        {({ input, meta }) => (
          <Form.Field error={meta.touched && meta.error}>
            <label>Net Weight</label>
            <Input
              type="number"
              placeholder="number"
              error={meta.touched && meta.error}
              label={{ basic: true, content: 'g' }}
              labelPosition="right"
              min="0"
              step="0.01"
              {...input}
            />
          </Form.Field>
        )}
      </Field>

      <Field name="quantity_value" type="number">
        {({ input, meta }) => (
          <Form.Field error={meta.touched && meta.error}>
            <label>Quantity Value</label>
            <Input
              type="number"
              placeholder="number"
              error={meta.touched && meta.error}
              min="0"
              step="0.01"
              {...input}
            />
          </Form.Field>
        )}
      </Field>

      <Field name="quantity_units">
        {({ input, meta }) => (
          <Form.Select
            label="Quantity Units"
            clearable
            error={meta.touched && meta.error}
            value={input.value}
            onChange={(_, { value }) => {
              input.onChange(value)
            }}
            options={QUANTITY_UNIT_OPTIONS}
            data-testid="quantity-units-select"
          />
        )}
      </Field>
    </>
  )
}
